import { useFormContext } from 'react-hook-form'
import { classNames } from 'utils/classNames'

type Props = {
  label: string
  name: string
  required?: boolean
}
export type FrequencyType = 'HIGH' | 'MIDDLE' | 'LOW' | 'NONE'

export const FrequencySelector = (props: Props): JSX.Element => {
  const { label, name, required } = props
  const { register } = useFormContext()

  const frequencyList = [
    { key: 'HIGH', value: '高' },
    { key: 'MIDDLE', value: '中' },
    { key: 'LOW', value: '低' },
    { key: 'NONE', value: '-' }
  ]
  const baseStyle =
    'w-full rounded border border-[#ddd] px-3 py-2 text-sm outline-none'
  return (
    <div className="flex flex-col">
      {label && (
        <label className={'mb-1.5 block text-sm font-medium text-[#555]'}>
          {label}
          {required && <span className={'text-red-500'}>{' *'}</span>}
        </label>
      )}
      <select
        className={classNames([baseStyle, 'focus:border-b-teal-400'])}
        {...register(name)}
      >
        {frequencyList.map((data) => (
          <option value={data.key} key={data.key}>
            {data.value}
          </option>
        ))}
      </select>
    </div>
  )
}
